// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/crypto/decaf377_rdsa/v1/decaf377_rdsa.proto (package penumbra.crypto.decaf377_rdsa.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message penumbra.crypto.decaf377_rdsa.v1.SpendAuthSignature
 */
export const SpendAuthSignature = proto3.makeMessageType(
  "penumbra.crypto.decaf377_rdsa.v1.SpendAuthSignature",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.crypto.decaf377_rdsa.v1.BindingSignature
 */
export const BindingSignature = proto3.makeMessageType(
  "penumbra.crypto.decaf377_rdsa.v1.BindingSignature",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message penumbra.crypto.decaf377_rdsa.v1.SpendVerificationKey
 */
export const SpendVerificationKey = proto3.makeMessageType(
  "penumbra.crypto.decaf377_rdsa.v1.SpendVerificationKey",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

